export default __webpack_public_path__ + "static/media/popup-mobile.4e3ad0c0.svg";